import React, {useState} from 'react';
import styled from "styled-components";
import {Icon} from "react-materialize";

const StyledSelectedTransaction = styled.div`
  border-bottom: 1px solid #B6B6B6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  
  .left-half {
    display: flex;
    
    i {
      padding-right: 1rem;
      font-size: 3rem;
      color: #5F6367;
      :hover {
        cursor: pointer;
        color: #92969b;
      }
    }
    
    p {
      padding-right: 4rem;
      color: #303030;
    }
  }
`

const SelectedUnreconciledTransaction = ({transaction, handleDelete}) => {
  const {date, type, sent, received, fee, source, transactionID, counterParty} = transaction;

  const handleClick = () => {
    handleDelete(false, transaction)
  }

  return (
    <StyledSelectedTransaction>
      <div className={'left-half'}>
        <Icon onClick={handleClick}>close</Icon>
        <p>{date}</p>
        <p>{type}</p>
        <p>{counterParty.name}</p>
      </div>
      <div>
        {sent.quantity} {sent.asset}
      </div>
    </StyledSelectedTransaction>
  )
}

export default SelectedUnreconciledTransaction;